import type { OptionsType, OptionType } from '@withjoy/joykit';
import { SelectV1 } from '@withjoy/joykit';
import React from 'react';

type TestEmailSelectorProps = {
  validEmails: string[];
  onChangeValue: (newValue: string) => void;
  currentValue: string;
};

export const TestEmailSelector = (props: TestEmailSelectorProps) => {
  const { validEmails, currentValue, onChangeValue } = props;

  const options: OptionsType<OptionType> = validEmails.map(email => {
    return {
      value: email,
      label: email,
    };
  });

  return (
    <SelectV1
      value={{
        label: currentValue,
        value: currentValue,
      }}
      searchable={false}
      onChange={option => {
        onChangeValue(option?.value ?? '');
      }}
      options={options}
    />
  );
};
